import React from "react"
import { useRange } from 'react-instantsearch';
import Rheostat from "rheostat"
import 'rheostat/initialize'; // important!
import 'rheostat/css/rheostat.css'; // ensure styles are imported

function RangeSlider({ attributeName, unit }) {
  const { start, range, refine } = useRange({ attribute: attributeName });
  	const { min, max } = range
	const onChange = ({ values }) => {
	//this.props.refine({ min: min, max: max })
	refine([values[0], values[1]]);
  };

	if(  !Number.isFinite(start[0]) )
	{
		start[0] = range.min;
	}
	if( !Number.isFinite( start[1]) )
	{
		start[1] = range.max;
	}
	return(
		    min !== max ?
            <div className="range-slider">
                <Rheostat
                    min={range.min}
                    max={range.max}
                    values={start}
                    onChange={onChange}
                 //   onValuesUpdated={this.onValuesUpdated}  
                />
                <div className="range-slider__labels">
                    <div>{start[0]}{unit}</div>
                    <div>{start[1]}{unit}</div>
                </div>
            </div> : null
	)
}
export default RangeSlider